import { ReactElement, ReactNode } from 'react';

const defaults = {
    i18n: function(key: i18nKey) {
        if (Array.isArray(key)) {
            return key[0];
        }
        return key;
    },

    pushPathPrefix: '/n1',
    useDynamicPageHeightFix: 100 as number | false,
    styleOverrides: {},

    //posielanie pushu b asi bolo vohnde vymysliet nejak rozumnejsie, cely tento "objekt", cely tento objekt nie je potrebny, ale aspon na oko takto
    channel: null as string,

    // prechod na / otvorenie login formulara
    gotoLoginForm: function() {
        console.warn('gotoLogin: not implemented');
    },

    // prechod na / otvorenie login formulara
    gotoHomepage: function() {
        window.location.href = '/';
    },

    onError: function(error) {
        console.warn('onError: not implemented', error);
    },

    // funkcia musi vracia close handler, a rovnako injecnut do elementu body close handler ako atribut 'close'
    openDialog: function(
        title?: ReactNode,
        body?: ReactElement,
        options?: { priority: number; closeAll: boolean }
    ): Function | undefined {
        console.warn('openDialog: not implemented');
        return () => {};
    },
    openTutorial: function() {
        console.warn('openTutorial: not implemented');
    },
    openStats: function(statisticsId: string, isTournament?: boolean) {
        console.warn('openStats: not implemented', statisticsId, isTournament);
    },
    openDialogMarketOptions: function(markets?: Object, onSelect?: Function, selectedMarket?: string) {
        console.warn('openDialog: not implemented');
        return () => {};
    },
    configProperty: function(name: string) {
        console.warn('configProperty: not implemented');
        return () => {};
    }
};

export type TurboliveConfiguration = typeof defaults;
type InitializeConfigurationArgs = Partial<TurboliveConfiguration>;
type LazyInitialization = () => InitializeConfigurationArgs;

let lazy: LazyInitialization;
let merged: TurboliveConfiguration;

export function initializeTurbolive(config: InitializeConfigurationArgs | LazyInitialization) {
    if (typeof config === 'function') {
        lazy = config;
        return;
    }
    merged = Object.assign(defaults, config);
}

export function getConfig() {
    if (!merged && typeof lazy === 'function') {
        initializeTurbolive(lazy());
    }
    return merged;
}

export function getStyleOverride(className) {
    return getConfig().styleOverrides[className];
}

export function openTutorial() {
    getConfig().openTutorial();
}

export function openStats(statisticsId, isTournament) {
    getConfig().openStats(statisticsId, isTournament);
}

export function openDialog(title, body, options) {
    getConfig().openDialog(title, body, options);
}

export function openDialogOptions(markets, onSelect, selectedMarket) {
    getConfig().openDialogMarketOptions(markets, onSelect, selectedMarket);
}

export function configProperty(name) {
    getConfig().configProperty(name);
}
